module.exports = __webpack_public_path__ + "img/二维码2.4fc2eac7.png";